"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const ActivityType_1 = __importDefault(require("@opsbase/lib-issue/ActivityType"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useDataSearch_1 = __importDefault(require("@opsbase/react-gql-datasearch/useDataSearch"));
const RelativeTimeChip_1 = __importDefault(require("@opsbase/web-chips/RelativeTimeChip"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Avatar_1 = require("@opsbase/web-ui/Avatar");
const react_1 = __importStar(require("react"));
const Callout_1 = __importDefault(require("./Callout"));
const IssueAssignedActivity_1 = __importDefault(require("./IssueAssignedActivity"));
const IssueEditedActivity_1 = __importDefault(require("./IssueEditedActivity"));
const makeMyClasses = () => ({
    callOut: {
        paddingTop: 10,
    },
    name: {
        color: lib_palette_1.default.GreyBlue.main,
        fontSize: 12,
        fontFamily: 'Gilroy',
        fontWeight: 'bold',
        paddingBottom: 4,
        '&.self': {
            textAlign: 'right',
        },
        '&.other': {},
    },
    comment: {
        justifyContent: 'flex-end',
        alignItems: 'center',
        '&.self': {
            paddingLeft: 16,
        },
        '&.other': {
            paddingRight: 16,
        },
    },
});
const IssueActivity = ({ activity, positionOverride, firstItem, lastItem, commentor: propsCommentor, isSelf, timezone, refProp, }) => {
    var _a, _b;
    const myCss = (0, web_css_1.default)(makeMyClasses, [firstItem, lastItem]);
    const position = (positionOverride !== null && positionOverride !== void 0 ? positionOverride : !isSelf) ? 'left' : 'right';
    const { data: commentorData } = (0, useDataSearch_1.default)(QueryFieldKey_1.default.STAFF, {
        id: [activity.staffId],
    }, undefined, !activity.staffId || !!propsCommentor);
    const commentor = propsCommentor !== null && propsCommentor !== void 0 ? propsCommentor : (_a = commentorData === null || commentorData === void 0 ? void 0 : commentorData.items) === null || _a === void 0 ? void 0 : _a[0];
    const content = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        switch (activity.type) {
            case ActivityType_1.default.ASSIGNED:
                return (react_1.default.createElement(IssueAssignedActivity_1.default, { activity: activity, position: position }));
            case ActivityType_1.default.EDITED:
                return (react_1.default.createElement(IssueEditedActivity_1.default, { activity: activity, position: position }));
            case ActivityType_1.default.RAISED: {
                const info = (_a = activity) === null || _a === void 0 ? void 0 : _a.activityInfo;
                return (react_1.default.createElement("span", { style: { textAlign: position, color: lib_palette_1.default.GreyBlue.main, fontSize: 12 } },
                    'Created a new issue: ',
                    react_1.default.createElement("span", { style: { fontFamily: 'Gilroy', fontWeight: 'bold' } }, info.issueTitle)));
            }
            case ActivityType_1.default.ADD_COMMENT: {
                const info = (_b = activity) === null || _b === void 0 ? void 0 : _b.activityInfo;
                return (react_1.default.createElement("span", { style: { textAlign: position, color: lib_palette_1.default.GreyBlue.main, fontSize: 12 } },
                    'Added a new comment: ',
                    react_1.default.createElement("span", { style: { fontFamily: 'Gilroy', fontWeight: 'bold' } }, info.title)));
            }
            case ActivityType_1.default.EDIT_COMMENT: {
                const info = (_c = activity) === null || _c === void 0 ? void 0 : _c.activityInfo;
                return (react_1.default.createElement("span", { style: { textAlign: position, color: lib_palette_1.default.GreyBlue.main, fontSize: 12 } },
                    'Edited a comment: ',
                    react_1.default.createElement("span", { style: { fontFamily: 'Gilroy', fontWeight: 'bold' } }, info.title)));
            }
            case ActivityType_1.default.DELETE_COMMENT: {
                return (react_1.default.createElement("span", { style: { textAlign: position, color: lib_palette_1.default.GreyBlue.main, fontSize: 12 } }, 'Deleted a comment'));
            }
            default:
                return (react_1.default.createElement("span", { style: { textAlign: position, color: lib_palette_1.default.GreyBlue.main, fontSize: 12 } }, activity.title));
        }
    }, [activity, position]);
    return (react_1.default.createElement("div", { style: {
            paddingTop: firstItem ? 16 : 0,
        }, ref: refProp },
        react_1.default.createElement(Horizontal_1.default, { justify: 'flex-start', reverse: isSelf },
            react_1.default.createElement(Horizontal_1.default, { justify: 'flex-start', style: {
                    flex: 0,
                    alignItems: 'flex-end',
                    marginRight: 10,
                    marginLeft: 10,
                    marginBottom: lastItem ? 24 : 0,
                    visibility: !lastItem ? 'hidden' : undefined,
                } },
                react_1.default.createElement(Avatar_1.Avatar, { user: commentor, allowEdit: false, size: 24 })),
            react_1.default.createElement(Vertical_1.default, null,
                firstItem ? (react_1.default.createElement(core_1.Typography, { variant: "subtitle2", className: myCss.name + (isSelf ? ' self' : ' other') }, (_b = commentor === null || commentor === void 0 ? void 0 : commentor.title) !== null && _b !== void 0 ? _b : '-')) : null,
                react_1.default.createElement(Callout_1.default, { variant: isSelf ? 'self' : 'other' }, content),
                lastItem ? (react_1.default.createElement(RelativeTimeChip_1.default, { time: activity.activityDate, timezone: timezone, textStyle: {
                        color: lib_palette_1.default.InputBorderGrey.main,
                        textAlign: isSelf ? 'right' : 'left',
                        fontSize: 12,
                        paddingTop: 4,
                    } })) : null))));
};
exports.default = IssueActivity;
